'use client';

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo, useState } from 'react';
import type { FlipbookCubeProps } from '../types';

/** FlipbookCube component for interactive cube preview with frame-by-frame animation */
export const FlipbookCube = t0 => {
  const $ = _c(12);
  const {
    imageUrl,
    alt,
    className,
    frames: t1
  } = t0;
  const frames = t1 === undefined ? 7 : t1;
  const [currentFrame, setCurrentFrame] = useState(0);
  let t2;
  if ($[0] !== frames) {
    t2 = e => {
      const rect = e.currentTarget.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const frameIndex = Math.floor(x / rect.width * frames);
      const clampedFrame = Math.max(0, Math.min(frames - 1, frameIndex));
      setCurrentFrame(clampedFrame);
    };
    $[0] = frames;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const handleMouseMove = t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      setCurrentFrame(0);
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const handleMouseLeave = t3;
  const backgroundPositionX = `${currentFrame / (frames - 1) * 100}%`;
  const t4 = `url(${imageUrl})`;
  const t5 = `${frames * 100}% 100%`;
  const t6 = `${backgroundPositionX} 0`;
  let t7;
  if ($[3] !== t4 || $[4] !== t5 || $[5] !== t6) {
    t7 = {
      backgroundImage: t4,
      backgroundSize: t5,
      backgroundPosition: t6,
      backgroundRepeat: "no-repeat",
      cursor: "pointer"
    };
    $[3] = t4;
    $[4] = t5;
    $[5] = t6;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  const t8 = `${alt} - Frame ${currentFrame + 1}/${frames}`;
  let t9;
  if ($[7] !== className || $[8] !== handleMouseMove || $[9] !== t7 || $[10] !== t8) {
    t9 = <div className={className} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave} style={t7} title={t8} />;
    $[7] = className;
    $[8] = handleMouseMove;
    $[9] = t7;
    $[10] = t8;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  return t9;
};